import { Component } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { addSettings } from "../../../actions";
import {
  listSalesOrders,
  singleCreditApplication,
} from "./../../../config/client_api_calls";

import $ from "jquery";

import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import { tableLoaderListing } from "../../../components/ContentLoaders/table_loader_listing";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import {
  THEME_TEXT_COLOR,
  THEME_COLOR,
  APP_LIVE_URL,
} from "./../../../config/config";

import dateFormat, { masks } from "dateformat";

import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import MoreHorizIcon from "@material-ui/icons/MoreHoriz";

const auth = new HelperClass();

const parseDateLocal = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
};

class SalesOrders extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      tableDataSingle: [],
      serviceData: [],
      tableLoaderListing: true,
      tableLoader: true,
      next_sequence_no: null,
      errorMessage: "",
      successMessage: "",

      anchorEl: null,
      selectedRowId: null,
      selectedRowStatus: null,

      columnServices: [
        {
          name: "orderno",
          label: "Order #",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.create_link(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "quote_accountno",
          label: "Quotation #",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.create_link_quotation(value, tableMeta)}</div>;
            },
          },
        },

        {
          name: "dateCreated",
          label: "Date Created",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{auth.formatDate(value)}</div>;
            },
          },
        },
        {
          name: "quote_attachement",
          label: "Invoice",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.viewPdf(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "quote_status",
          label: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setStatus(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "payment_status",
          label: "Payment Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setPaymentStatus(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "order_via_form",
          label: "View Order Form",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.viewOrderForm(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "form_token",
          label: "Form Token",
          options: {
            display: false,
            filter: false,
            viewColumns: false,
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              const rowId = tableMeta.rowData[0];
              const status = tableMeta.rowData[4];

              return (
                <>
                  <IconButton
                    size="small"
                    onClick={(event) =>
                      this.handleMenuOpen(event, rowId, status)
                    }
                    style={{
                      border: "1px solid #dbdfea",
                      borderRadius: "6px",
                      padding: "6px",
                      backgroundColor: "#fff",
                      outline: "none",
                    }}
                  >
                    <MoreHorizIcon fontSize="small" />
                  </IconButton>
                </>
              );
            },
          },
        },
      ],
    };
  }

  handleMenuOpen = (event, rowId, status) => {
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: rowId,
      selectedRowStatus: status,
    });
  };

  handleMenuClose = () => {
    this.setState({
      anchorEl: null,
      selectedRowId: null,
      selectedRowStatus: null,
    });
  };

  async componentDidMount() {
    window.addEventListener("scroll", this.handleMenuClose);
    const servicesResponce = await listSalesOrders(
      auth.getClientAccount(),
      auth.getClientToken(),
    );
    // console.log("Available SalesOrders: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
        next_sequence_no: servicesResponce.data.next_sequence_no,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoader: false,
        tableLoaderListing: false,
        next_sequence_no: servicesResponce.data.next_sequence_no,
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
        next_sequence_no: servicesResponce.data.next_sequence_no,
      });
      //window.location.replace("/error");
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleMenuClose);
  }

  setStatus = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === "pending") {
      return (
        <div>
          <span className="badge badge-outline-primary">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> Pending
          </span>
        </div>
      );
    } else if (domain_str === "approved") {
      return (
        <div>
          <span className="badge badge-outline-success">
            {" "}
            <em className="icon ni ni-done "></em> Approved
          </span>
        </div>
      );
    } else if (domain_str === "cancelled") {
      return (
        <div>
          <span className="badge badge-outline-danger">
            {" "}
            <em className="icon ni ni-alert-c"></em> Cancelled
          </span>
        </div>
      );
    } else if (domain_str === "in_review") {
      return (
        <div>
          <span className="badge badge-outline-secondary">
            {" "}
            <em className="icon ni ni-alert-c"></em> In Review
          </span>
        </div>
      );
    } else if (domain_str === "converted") {
      return (
        <div>
          <span className="badge badge-outline-primary">
            {" "}
            <em className="icon ni ni-alert-c"></em> Converted
          </span>
        </div>
      );
    } else if (domain_str === "completed") {
      return (
        <div>
          <span className="badge badge-success">
            {" "}
            <em className="icon ni ni-done"></em> Completed
          </span>
        </div>
      );
    }
  };

  setPaymentStatus = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === "unpaid") {
      return (
        <div>
          <span className="badge badge-outline-danger">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> Unpaid
          </span>
        </div>
      );
    } else if (domain_str === "paid") {
      return (
        <div>
          <span className="badge badge-outline-success">
            {" "}
            <em className="icon ni ni-done "></em> Paid
          </span>
        </div>
      );
    } else if (domain_str === "partial") {
      return (
        <div>
          <span className="badge badge-outline-warning">
            {" "}
            <em className="icon ni ni-coins"></em> Partial
          </span>
        </div>
      );
    }
  };

  viewOrderForm = (value, tableMeta) => {
    const form_token = tableMeta.rowData[7]; // form_token is at index 7

    if (form_token && form_token !== "") {
      return (
        <a
          onClick={() =>
            this.addMenuHistory(
              "/" +
                auth.getResellerRegToken() +
                "/client/client_form_submission_single/" +
                form_token,
            )
          }
          className="btn btn-sm btn-primary"
          style={{
            cursor: "pointer",
            display: "inline-block",
            color: "white",
            padding: "0.25rem 0.6rem",
          }}
          disabled={
            this.props.is_msa_signed === "No" ||
            this.props.defaultSettings === "missing"
          }
        >
          {/* <em className="icon ni ni-arrow-up"></em> */}
          <span style={{ paddingLeft: "0px" }}>View Order Form</span>
        </a>
      );
    } else {
      return <span>...</span>;
    }
  };

  setComplete = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === "incomplete") {
      return (
        <div>
          <span className="badge badge-outline-warning">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> In Progress
          </span>
        </div>
      );
    } else if (domain_str === "complete") {
      return (
        <div>
          <span className="badge badge-outline-secondary">
            {" "}
            <em className="icon ni ni-done "></em> Submitted
          </span>
        </div>
      );
    }
  };

  viewPdf = (value, tableMeta) => {
    let domain_str = value;
    const rowIndex = tableMeta.rowIndex;
    const orderno = tableMeta.rowData[0];
    //console.log("domain_str: ", domain_str);
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {/* {domain_str && domain_str !== "" ? (
          this.state.downloadingIndex === rowIndex ? (
            <span className="badge badge-outline-light">
              {" "}
              <em className="icon ni ni-download"></em> Downloading...
            </span>
          ) : (
            <a
              onClick={() => {
                this.setState({ downloadingIndex: rowIndex });
                setTimeout(() => {
                  this.downloadPdf(value, tableMeta);
                }, 2000);
              }}
              style={{ cursor: "pointer" }}
              title="Download PDF"
            >
              <span className="badge badge-outline-secondary">
                {" "}
                <em className="icon ni ni-file-pdf"></em> View Attachement
              </span>
            </a>
          )
        ) : (
          <span className="badge badge-outline-light">
            {" "}
            <em className="icon ni ni-file-pdf"></em> No Attachement
          </span>
        )} */}
        <a
          onClick={() =>
            this.addMenuHistory(
              "/" +
                auth.getResellerRegToken() +
                "/client/Invoices?orderno=" +
                orderno,
            )
          }
          style={{ cursor: "pointer" }}
          title="View Invoice"
        >
          <span className="badge badge-outline-primary">
            {" "}
            <em className="icon ni ni-notes-alt"></em> View Invoices
          </span>
        </a>
      </div>
    );
  };

  create_link = (value, tableMeta) => {
    let quote_accountno = tableMeta.rowData[0];
    if (quote_accountno !== "") {
      return (
        <div>
          <a
            style={{ cursor: "pointer", textDecoration: "underline" }}
            className="text-primary"
            onClick={() =>
              this.addMenuHistory(
                "/" +
                  auth.getResellerRegToken() +
                  "/client/ViewSalesOrder/" +
                  tableMeta.rowData[0],
              )
            }
            data-toggle="tooltip"
            data-placement="top"
            title="View Quotation"
            disabled={
              this.props.is_msa_signed === "No" ||
              this.props.defaultSettings === "missing"
                ? true
                : false
            }
          >
            {quote_accountno}
          </a>
        </div>
      );
    }
  };

  create_link_quotation = (value, tableMeta) => {
    let quote_accountno = tableMeta.rowData[1];
    if (quote_accountno !== "") {
      return (
        <div>
          <a
            style={{ cursor: "pointer", textDecoration: "underline" }}
            className="text-primary"
            onClick={() =>
              this.addMenuHistory(
                "/" +
                  auth.getResellerRegToken() +
                  "/client/ViewQuotation/" +
                  tableMeta.rowData[1],
              )
            }
            data-toggle="tooltip"
            data-placement="top"
            title="View Quotation"
            disabled={
              this.props.is_msa_signed === "No" ||
              this.props.defaultSettings === "missing"
                ? true
                : false
            }
          >
            {quote_accountno}
          </a>
        </div>
      );
    }
  };

  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };

  serviceSigning = async (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  defaultText = (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let is_default = tableMeta.rowData[5];
    if (is_default === "No") {
      return (
        <a
          style={{ cursor: "pointer" }}
          onClick={() => this.setDefaultService(value, tableMeta)}
          disabled={
            this.props.is_msa_signed === "No" ||
            this.props.defaultSettings === "missing"
              ? true
              : false
          }
        >
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-signin"></em> Make Default
          </span>
        </a>
      );
    } else {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    }
  };

  setMarkUp = async (value, tableMeta) => {
    let service_id = tableMeta.rowData[0];

    window.$("#modalForm").modal("show");
  };

  format_date = (value, tableMeta) => {
    const d = parseDateLocal(value);
    return d ? dateFormat(d, "mm-dd-yyyy, h:MM:ss TT") : "---";
  };

  downloadPdf = async (d_f_name, tableMeta) => {
    var url = d_f_name;
    let file_name = "";
    let check_url = this.isStringURL(url);
    // console.log("check_url: " + check_url + " " + url);
    if (check_url === true) {
      file_name = this.getFileNameFromUrl(url);
    } else {
      file_name = url;
      url = APP_LIVE_URL + "files_data/rfq/" + url;
    }
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = file_name;
        a.click();
        window.URL.revokeObjectURL(url);
        this.setState({ errorMessage: "", downloadingIndex: null });
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
          downloadingIndex: null,
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  getFileNameFromUrl = (url) => {
    try {
      const urlObject = new URL(url);
      // Using the pathname for simplicity; adjust as needed based on your URL structure
      const fileName = urlObject.pathname.split("/").pop();
      return fileName;
    } catch (error) {
      console.error("Error extracting file name:", error);
      return "attachement";
    }
  };

  isStringURL = (str) => {
    try {
      new URL(str);
      return true;
    } catch (error) {
      return false;
    }
  };

  handleChanges = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleChangeCheckbox = (input) => (e) => {
    this.setState({
      [input]:
        e.target.type === "checkbox" ? e.target.checked : e.target.checked,
    });
    //console.log("handleChangeCheckbox: ", input);
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  generateRandomNumber = (link) => {
    const min = 1000000; // Minimum 10-digit number (10^9)
    const max = 9999999; // Maximum 10-digit number (10^10 - 1)
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    this.props.history.push(link + "/" + randomNumber);
  };

  addMenuHistory = (link) => {
    this.props.history.push(link);
  };

  add_sales_order = async () => {
    window.$("#modalFormClients").modal("hide");
    this.addMenuHistory(
      "EditSalesOrder/" + this.state.next_sequence_no + "?order=add",
    );
  };

  render() {
    const { step } = this.state;
    const { email, VerifyUsernameButton } = this.state;
    const values = {
      email,
      VerifyUsernameButton,
    };
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    return (
      <div
        className={
          this.props.from === "dashboard"
            ? "nk-content newcontent_padding"
            : "nk-content"
        }
        id="Support_Block"
      >
        <div
          className={
            this.props.from === "dashboard"
              ? "container-fluid newcontainerfluid_padding"
              : "container-fluid"
          }
        >
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              {/* RIGHTS MODAL START */}

              {/* RIGHTS MODAL End */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Orders" icon="icon ni ni-notes-alt" />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="salesOrderMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="salesOrderMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            <a
                              style={{ cursor: "pointer", color: "#fff" }}
                              onClick={() =>
                                this.addMenuHistory(
                                  "EditSalesOrder/" +
                                    this.state.next_sequence_no +
                                    "?order=add",
                                )
                              }
                              className="btn btn-primary"
                            >
                              <em className="icon ni ni-plus-round"></em>
                              &nbsp;Add New Order
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert example-alert-revoke mt-3 mb-3"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.tableLoader === true ? (
                            TableLoader()
                          ) : (
                            <DataTableExtended
                              columns={this.state.columnServices}
                              tableData={this.state.tableData}
                              title=""
                            />
                          )}
                          <Menu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleMenuClose}
                            keepMounted
                            getContentAnchorEl={null}
                            disableAutoFocusItem
                            disableEnforceFocus
                            disableScrollLock
                            disablePortal
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            container={document.getElementById("tabItemSigned")}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            PaperProps={{
                              style: {
                                minWidth: 150,
                                width: "auto",
                                style: {
                                  minWidth: 150,
                                  width: "auto",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  color: "#526484",
                                  lineHeight: "1.3rem",
                                },
                              },
                            }}
                          >
                            {/* VIEW */}
                            <MenuItem
                              disabled={
                                this.props.is_msa_signed === "No" ||
                                this.props.defaultSettings === "missing"
                              }
                              onClick={() => {
                                this.addMenuHistory(
                                  "/" +
                                    auth.getResellerRegToken() +
                                    "/client/ViewSalesOrder/" +
                                    this.state.selectedRowId,
                                );
                                this.handleMenuClose();
                              }}
                            >
                              <em className="icon ni ni-list pr-md-2 pr-1"></em>
                              View
                            </MenuItem>

                            {/* EDIT — commented out: Edit action disabled on Sales Orders listing */}
                            {/* {(this.state.selectedRowStatus === "pending" ||
                              this.state.selectedRowStatus === "in_review") && (
                              <MenuItem
                                onClick={() => {
                                  this.addMenuHistory(
                                    "/" +
                                      auth.getResellerRegToken() +
                                      "/client/EditSalesOrder/" +
                                      this.state.selectedRowId,
                                  );
                                  this.handleMenuClose();
                                }}
                              >
                                <em className="icon ni ni-edit pr-md-2 pr-1"></em>
                                Edit
                              </MenuItem>
                            )} */}
                          </Menu>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SalesOrders));
